import { defaultApi } from "@/services/axiosInstances";

const MAX_CACHE_AGE = 5 * 60 * 1000;

export default {
	namespaced: true,
	state: {
		dataMap: {},
		statusMap: {},
		timestamps: {},
	},
	getters: {
		getDataById: (state) => (id) => state.dataMap[id],
		getStatusById: (state) => (id) => state.statusMap[id],
	},
	mutations: {
		setLoading(state, id) {
			state.statusMap[id] = "loading";
		},
		setSuccess(state, { id, data }) {
			state.dataMap[id] = data;
			state.statusMap[id] = "success";
			state.timestamps[id] = Date.now();
		},
		setNotFound(state, id) {
			state.statusMap[id] = "not_found";
			state.timestamps[id] = Date.now();
		},
		setError(state, id) {
			state.statusMap[id] = "error";
		},
		clearData(state, id) {
			delete state.dataMap[id];
			delete state.statusMap[id];
			delete state.timestamps[id];
		},
	},
	actions: {
		async fetchData({ state, commit }, siswaId) {
			const status = state.statusMap[siswaId];
			const timestamp = state.timestamps[siswaId];

			const now = Date.now();
			const isExpired = timestamp ? now - timestamp > MAX_CACHE_AGE : true;

			if (!isExpired && status === "success") {
				return;
			}

			commit("setLoading", siswaId);
			try {
				const { data } = await defaultApi.post("/title/siswa", {
					siswa_id: siswaId,
				});

				if (data) {
					commit("setSuccess", { id: siswaId, data: data.siswa });
				} else {
					commit("setNotFound", siswaId);
				}
			} catch (error) {
				console.error(error.response?.data?.message);
				commit("setError", siswaId);
			}
		},
	},
};
